import { put, select } from 'redux-saga/effects';
import { loadZones } from '../actions';
import processError from '../../../utils/processError';
import { getToken } from '../../../utils/redux';

export default function* initParkingMeter() {
  try {
    const token = yield select(getToken);
    if (token) {
      const p = yield put(loadZones());
      p.catch(e => processError(e));
    }
  } catch (e) {
    yield processError(e);
  }
}
